import createReactComponent from '../createReactComponent';
var Bold = createReactComponent('Bold', [['path', {
  d: 'M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z',
  key: '1un85i'
}], ['path', {
  d: 'M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z',
  key: '10pd50'
}]]);
export default Bold;